export default {
    methods: {
        getImageUrl(img) {
            return require("../assets/images/" + img);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/appMixins.js